import { render, staticRenderFns } from "./AddShapeModal.vue?vue&type=template&id=20ce66e6&scoped=true"
import script from "./AddShapeModal.vue?vue&type=script&lang=js"
export * from "./AddShapeModal.vue?vue&type=script&lang=js"
import style0 from "./AddShapeModal.vue?vue&type=style&index=0&id=20ce66e6&lang=css"
import style1 from "./AddShapeModal.vue?vue&type=style&index=1&id=20ce66e6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ce66e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/minhochoi/projects/MAPPING/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20ce66e6')) {
      api.createRecord('20ce66e6', component.options)
    } else {
      api.reload('20ce66e6', component.options)
    }
    module.hot.accept("./AddShapeModal.vue?vue&type=template&id=20ce66e6&scoped=true", function () {
      api.rerender('20ce66e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AddShapeModal.vue"
export default component.exports